import { MimshakDataService } from "./mimshakDataService";

class MimshakDataPreAdviceService extends MimshakDataService {
    constructor() {
      super("/mimshak_data_pre_advice");
    }
  }
  
  export const mimshakDataPreAdviceService = new MimshakDataPreAdviceService();
  